module.exports = __webpack_public_path__ + "static/media/Carlos.cb574176.png";